var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgProfileFeedbackSuccess = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M26.848 35.566c0 7.929 6.489 14.365 14.446 14.365 7.958 0 14.43-6.452 14.446-14.365v-8.201C55.74 19.436 49.252 13 41.294 13c-7.973 0-14.446 6.436-14.446 14.365v8.201Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M31.1 37.04c0 6.587 5.214 11.934 11.609 11.934s11.596-5.36 11.61-11.935v-6.814c0-6.588-5.215-11.935-11.61-11.935-6.408 0-11.61 5.347-11.61 11.935v6.814Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M54.915 36.107c0 4.21-1.386 7.523-3.752 9.784-2.37 2.265-5.797 3.546-10.004 3.546s-7.582-1.28-9.902-3.541c-2.317-2.258-3.66-5.57-3.66-9.789 0-1.012-.047-2.593-.095-4.176l-.002-.073c-.049-1.618-.097-3.231-.097-4.284 0-8.884 7.376-13.756 13.756-13.756s13.756 4.872 13.756 13.756v8.533Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M16.234 75.952c5.44 2.857 14.836 6.035 24.925 6.035 10.088 0 19.772-3.178 25.212-6.035a5.912 5.912 0 0 0 3.18-4.911c.451-7.367-2.018-11.139-4.181-13-1.033-.9-2.357-1.541-4.02-1.942-5.648-1.349-11.167-5.415-11.232-5.479-5.973 3.407-12.373 2.98-18.346-.006-7.68 5.12-6.622 4.555-10.518 5.485-1.663.4-2.987 1.043-4.02 1.942-2.162 1.861-4.632 5.633-4.18 13a5.912 5.912 0 0 0 3.18 4.911Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M31.772 50.614c-.064.064-4.87 4.13-10.518 5.478-1.663.401-2.987 1.043-4.02 1.942-2.162 1.862-4.632 5.634-4.18 13 .13 2.087 1.487 4.2 3.36 5.178 5.439 2.857 14.656 5.769 24.745 5.769 10.088 0 19.732-2.912 25.172-5.769 1.872-.979 3.09-3.09 3.22-5.177.451-7.367-2.018-11.139-4.181-13-1.033-.9-2.357-1.542-4.02-1.943-5.648-1.348-11.167-5.414-11.232-5.478"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M68.512 83c7.62 0 13.797-6.176 13.797-13.796 0-7.62-6.177-13.798-13.797-13.798-7.62 0-13.797 6.178-13.797 13.798S60.892 83 68.512 83Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    stroke: "var(--color-neutral-70)",
    strokeWidth: 1.5,
    d: "M64.322 68.687a.427.427 0 0 0-.606 0 .43.43 0 0 0 0 .607l2.855 2.863a.427.427 0 0 0 .606 0l6.28-6.298a.43.43 0 0 0 0-.607.427.427 0 0 0-.606 0l-5.977 5.994-2.552-2.559Z",
    clipRule: "evenodd"
  }));
};
export default SvgProfileFeedbackSuccess;